import { Component } from '@angular/core';

@Component({
  selector: 'app-generic-table-skeleton',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.scss']
})
export class GenericTableComponent {

}
